import { HashableEntity } from "./HashableEntity";

export class Domain extends HashableEntity {
  public challenge = "";
}
